import { LogLevel } from '@amplitude/analytics-types';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Legacy import for amplitude logger interface
import { ILogger } from '@amplitude/analytics-core/lib/esm/logger';
import { addBreadcrumb, captureException } from '@sentry/browser';
import { captureMessage } from '@sentry/react';

export class SentryLogger implements ILogger {
  enable(logLevel: LogLevel): void {
    addBreadcrumb({
      message: 'Logger enabled: Log level set to ' + LogLevel[logLevel],
      category: 'log',
      level: 'info',
    });
  }

  disable(): void {
    addBreadcrumb({
      message: 'Logger disabled',
      category: 'log',
      level: 'info',
    });
  }

  log(): void {}

  warn(...args: unknown[]): void {
    addBreadcrumb({
      category: 'warn',
      message: args.join(' '),
      level: 'warning',
    });
    captureMessage(args.join(' '), 'warning');
  }

  error(...args: unknown[]): void {
    const errorMessage = args.join(' ');

    // Фильтруем ошибки удалённой конфигурации Amplitude
    if (
      errorMessage.includes('Failed to fetch remote configuration') ||
      errorMessage.includes('fetchRemoteConfig')
    ) {
      console.warn('Amplitude remote config error (non-critical):', errorMessage);

      // Записываем как предупреждение, а не ошибку
      addBreadcrumb({
        category: 'amplitude_warning',
        message: errorMessage,
        level: 'warning',
      });

      // Не отправляем как критическую ошибку в Sentry
      captureMessage(`Amplitude remote config warning: ${errorMessage}`, 'warning');
      return;
    }

    // Для остальных ошибок - обычная обработка
    captureException(new Error(errorMessage));
  }

  debug(): void {}
}
